import React, { useEffect, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MillstageDropDownFilter from "../../../components/FilterBox/Millstage/MillstageDropDownFilter";
import MillstageFilterBox from "../../../components/FilterBox/Millstage/MillstageFilter";
import { FiMenu } from "react-icons/fi";
import { Loader } from "../../../components/Loader/Loader";
import MillstageTable from "../../../components/Tables/MillstageTable";
import {
  GreyStageBalance,
  GreyStageBalanceFun,
  StageFilters,
} from "../../../Redux/Slice/Millstage/MillstageSlice";
import { useTheme } from "../../../Themecontext/Themecontext";

export const GreystageBalance = () => {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { StageFiltersdata, GreyStageBalancedata } = useSelector(
    (state) => state.MillstageSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWMILLSTAGEDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const [activeTable, setActiveTable] = useState("INWARD");

  const [productionGroupSearch, setProductionGroupSearch] = useState("");
  const [stageGroupSearch, setStageGroupSearch] = useState("");
  const [partyNameSearch, setPartyNameSearch] = useState("");

  const [productionGroupId, setProductionGroupId] = useState([]);
  const [stageGroupId, setStageGroupId] = useState([]);
  const [partyNameId, setPartyNameId] = useState([]);

  useEffect(() => {
    dispatch(StageFilters());
    dispatch(GreyStageBalance({}));
  }, [dispatch]);

  const [filter, setFilter] = useState({
    productionGroup: [],
    stageGroup: [],
    partyName: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
    stageGroup: "",
    partyName: "",
  });

  const productionGroupList =
    StageFiltersdata?.ProdGrp?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const stageGroupList =
    StageFiltersdata?.Stage?.map((item) => ({
      label: item?.StageName,
      value: item?.StageID,
    })) || [];

  const partyNameList =
    StageFiltersdata?.Ac?.map((item) => ({
      label: item?.ACName,
      value: item?.AcID,
    })) || [];

  const TableChartColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Delivery",
      key: "Delivery",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Shortage", key: "Shortage", align: "right", format: "true" },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
  ];

  const TableChartRow = (GreyStageBalancedata?.Delivery || []).map((row) => ({
    Delivery: row?.Delivery ?? 0,
    Meter: row?.Meter ?? 0,
    Shortage: row?.Shortage ?? 0,
    Taka: row?.Taka ?? 0,
  }));

  const TableChartColumns1 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "GroupName",
      key: "GroupName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "TP", key: "TP", align: "right", format: "true" },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
  ];

  const TableChartRow1 = (GreyStageBalancedata?.Group || []).map((row) => ({
    GroupName: row?.GroupName ?? 0,
    Meter: row?.Meter ?? 0,
    TP: row?.TP ?? 0,
    Taka: row?.Taka ?? 0,
  }));

  const TableChartColumns2 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Inward",
      key: "Inward",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
  ];

  const TableChartRow2 = (GreyStageBalancedata?.Inward || []).map((row) => ({
    Inward: row?.Inward ?? 0,
    Meter: row?.Meter ?? 0,
    Taka: row?.Taka ?? 0,
  }));

  const TableChartColumns3 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Stage", key: "Stage", align: "right", format: "true" },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    { label: "TP", key: "TP", align: "right", format: "true" },
    { label: "Taka", key: "Taka", align: "right", format: "true" },
  ];

  const TableChartRow3 = (GreyStageBalancedata?.Stage || []).map((row) => ({
    Stage: row?.Stage ?? 0,
    Meter: row?.Meter ?? 0,
    TP: row?.TP ?? 0,
    Taka: row?.Taka ?? 0,
  }));

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const handleSubmit = () => {
    dispatch(GreyStageBalanceFun());

    dispatch(
      GreyStageBalance({
        GroupIds: filter.productionGroup.join(","),
        StageIds: filter.stageGroup.join(","),
        PartyIDs: filter.partyName.join(","),
      }),
    );

    setShowFilter(false)

  };


  const handleSubmit1 = () => {
    dispatch(GreyStageBalanceFun());

    dispatch(
      GreyStageBalance({
        GroupIds: productionGroupId.join(","),
        StageIds: stageGroupId.join(","),
        PartyIDs: partyNameId.join(","),
      }),
    );
  };

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  if (!StageFiltersdata) {
    return (
      <div className=" flex justify-center items-center h-screen ">
        <Loader />
      </div>
    );
  }

  if (!GreyStageBalancedata || GreyStageBalancedata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        style={{
          background: isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }}
        >
          <Offcanvas.Title

          >

            Filters

          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <MillstageFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <MillstageFilterBox
              title="Stage Group"
              items={stageGroupList}
              search={search.stageGroup}
              setSearch={(val) => handleSearch("stageGroup", val)}
              selectedItems={filter.stageGroup}
              toggleItem={(item) => toggleItem("stageGroup", item)}
              selectAll={() => selectAll("stageGroup", stageGroupList)}
            />
            <MillstageFilterBox
              title="Party Name"
              items={partyNameList}
              search={search.partyName}
              setSearch={(val) => handleSearch("partyName", val)}
              selectedItems={filter.partyName}
              toggleItem={(item) => toggleItem("partyName", item)}
              selectAll={() => selectAll("partyName", partyNameList)}
            />

            <Button
              onClick={handleSubmit}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                // height: "45px",
                border: "none",
              }}
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour10,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7
            }`,
        }}
      >
        <Row className="g-2 align-items-end ">

          <Col xl={3} lg={6}>
            <MillstageDropDownFilter
              label="Production Group"
              data={productionGroupList}
              selectedValue={productionGroupSearch}
              setSelectedValue={setProductionGroupSearch}
              selectedId={productionGroupId}
              setSelectedId={setProductionGroupId}
              placeholder="Select Production Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          <Col xl={3} lg={6}>
            <MillstageDropDownFilter
              label="Stage Group"
              data={stageGroupList}
              selectedValue={stageGroupSearch}
              setSelectedValue={setStageGroupSearch}
              selectedId={stageGroupId}
              setSelectedId={setStageGroupId}
              placeholder="Select Stage Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>
          <Col xl={3} lg={6}>
            <MillstageDropDownFilter
              label="Party Name"
              data={partyNameList}
              selectedValue={partyNameSearch}
              setSelectedValue={setPartyNameSearch}
              selectedId={partyNameId}
              setSelectedId={setPartyNameId}
              placeholder="Select Party Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* BUTTON */}
          <Col xl={3} lg={6}>
            <button
              onClick={handleSubmit1}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                // height: "45px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <Row className="mt-4 mb-3 g-2">
        {["INWARD", "DELIVERY", "GROUPWISE", "STAGEWISE"].map((btn) => (
          <Col xs={12} sm={6} md={3} key={btn}>
            <button
              onClick={() => setActiveTable(btn)}
              style={{
                width: "100%",
                height: "50px",
                borderRadius: "12px",
                cursor: "pointer",
                fontWeight: "600",
                border: `2px solid ${isdark === "light"
                  ? iscolour?.Colour6
                  : iscolourDark?.Colour6
                  }`,
                background:
                  activeTable === btn
                    ? isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour6
                    : isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour10,
                color:
                  activeTable === btn
                    ? isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1
                    : isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour1,
              }}
            >
              {btn}
            </button>
          </Col>
        ))}
      </Row>

      <Row className="mt-3">
        <Col xs={12}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {/* Header */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour4,
                color: "#fff",
                fontWeight: "600",
                letterSpacing: "1px"
              }}
            >
              {activeTable}
            </div>

            {/* Table */}
            <MillstageTable
              columns={
                activeTable === "INWARD"
                  ? TableChartColumns2
                  : activeTable === "DELIVERY"
                    ? TableChartColumns
                    : activeTable === "GROUPWISE"
                      ? TableChartColumns1
                      : TableChartColumns3
              }
              data={
                activeTable === "INWARD"
                  ? TableChartRow2
                  : activeTable === "DELIVERY"
                    ? TableChartRow
                    : activeTable === "GROUPWISE"
                      ? TableChartRow1
                      : TableChartRow3
              }
            />
          </div>
        </Col>
      </Row>


    </div>
  );
};

export default GreystageBalance;
